import {IczFormControl, IczFormGroup, IczValidators, TextLength} from '@icz/angular-form-elements';
import {
  EmpowermentDto,
  FileForm,
  FileHandlingType,
  FileReferenceCreationType,
  FileState,
  ObjectClass
} from '|api/commons';
import {getCustomFieldsFormArray} from '|shared';

/**
 * Do not add default disabled state of fields in contructor of IczFormControl. Add it in method setFileFormDisabledState
 * because disabled state of form can change when file state changes and file is reloaded.
 */
export function createFileDetailFormGroup(): IczFormGroup {
  return new IczFormGroup({
    createdByFunctionalPosition: new IczFormControl<Nullable<number>>(null),
    customMarker: new IczFormControl<Nullable<string>>(),
    description: new IczFormControl<Nullable<string>>(),
    executionDate: new IczFormControl<Nullable<string>>(),
    fileForm: new IczFormControl<Nullable<FileForm>>({value: null, disabled: true}, [IczValidators.required()]),
    fileHandlingType: new IczFormControl<Nullable<FileHandlingType>>(null),
    fileReferenceCreationType: new IczFormControl<Nullable<FileReferenceCreationType>>(null),
    fileState: new IczFormControl<Nullable<FileState>>(null),
    fileTypeId: new IczFormControl<Nullable<number>>(null),
    id: new IczFormControl<Nullable<number>>(), // not in DTO
    holderFunctionalPositionIds: new IczFormControl<Nullable<number[]>>([]),
    initialDocumentId: new IczFormControl<Nullable<number>>(),
    label: new IczFormControl<Nullable<string>>(),
    note: new IczFormControl<Nullable<string>>(),
    relatedEvidence: new IczFormControl<Nullable<string>>(),
    keywordIds: new IczFormControl<Nullable<number[]>>(null, []),
    objectClass: new IczFormControl<Nullable<ObjectClass>>(),
    ownerFunctionalPositionId: new IczFormControl<Nullable<number>>(null),
    packageId: new IczFormControl<Nullable<number>>(),
    physicalLocation: new IczFormControl<Nullable<string>>(),
    refNumberCreationType: new IczFormControl<Nullable<string>>(),
    resolutionDate: new IczFormControl<Nullable<string>>(),
    securityCategoryId: new IczFormControl<Nullable<number>>(null),
    sourceUid: new IczFormControl<Nullable<string>>(),
    subject: new IczFormControl<Nullable<string>>(null, [IczValidators.required(), IczValidators.maxLength(100)], undefined, TextLength.UNLIMITED),
    entityClassId: new IczFormControl<Nullable<number>>(null, [IczValidators.required()]),
    uid: new IczFormGroup({
      uid: new IczFormControl<Nullable<string>>(null),
    }),
    auditInfo: new IczFormGroup({
      createdAt: new IczFormControl<Nullable<string>>(null),
      createdBy: new IczFormControl<Nullable<string>>(null),
      modifiedAt: new IczFormControl<Nullable<string>>(null),
    }),
    deactivateAuditInfo: new IczFormGroup({
      deactivationDate: new IczFormControl<Nullable<string>>(null),
      deactivationReason: new IczFormControl<Nullable<string>>(),
    }),
    deleteAuditInfo: new IczFormGroup({
      deletedAt: new IczFormControl<Nullable<string>>(null),
      reason: new IczFormControl<Nullable<string>>(null),
      deletedByFunctionalPositionId: new IczFormControl<Nullable<number>>(null),
    }),
    empowerment: new IczFormControl<Nullable<EmpowermentDto>>(null),
    issdId: new IczFormControl<Nullable<string>>({value: null, disabled: true}),
    disposalScheduleId: new IczFormControl<Nullable<string>>(null),
    externalRetentionTriggerIds: new IczFormControl<Nullable<string>>(null),
    yearOfRetentionPeriodStart: new IczFormControl<Nullable<number>>(null),
    triggerEventCheckYear: new IczFormControl<Nullable<number>>({value: null, disabled: true}),
    disposalYear: new IczFormControl<Nullable<number>>({value: null, disabled: true}),
    disposalOperationCode: new IczFormControl<Nullable<number>>({value: null, disabled: true}),
    customFieldValues: getCustomFieldsFormArray(),
  });
}

export function setFileFormDisabledState(documentForm: IczFormGroup) {
  const fieldsToBeDisabled = [
    'createdByFunctionalPosition',
    'fileHandlingType',
    'fileReferenceCreationType',
    'fileState',
    'fileForm',
    'holderFunctionalPositionIds',
    'ownerFunctionalPositionId',
    'uid.uid',
    'auditInfo.createdAt',
    'auditInfo.createdBy',
    'auditInfo.modifiedAt',
    'deleteAuditInfo.deletedAt',
    'deleteAuditInfo.reason',
    'deleteAuditInfo.deletedByFunctionalPositionId',
    'issdId',
  ];
  fieldsToBeDisabled.forEach(fieldName => {
    documentForm.get(fieldName)?.disable();
  });
}
